/** Routes hidden from nav and redirected to dashboard until re-enabled. */
export const DISABLED_ROUTES = [
  "/video-create",
  "/create-video",
  "/create-template",
  "/video-configuration",
  "/videos",
  "/templates",
] as const;

export function isDisabledRoute(pathname: string): boolean {
  if (DISABLED_ROUTES.includes(pathname as (typeof DISABLED_ROUTES)[number])) {
    return true;
  }
  return /^\/templates\/[^/]+\/edit\/?$/.test(pathname);
}
